import { DemoMatch } from 'types/demos';

/**
 * Ensures a filename has the .dem extension
 */
const ensureDemExtension = (name: string): string => {
    return name.endsWith('.dem') ? name : `${name}.dem`;
};

/**
 * Get a display-friendly name for a demo match
 * @param match - The demo match object
 * @returns A display name - uses displayName if available, otherwise generates from match data
 */
export const getDisplayName = (match: DemoMatch): string => {
    // Use displayName from backend if available
    if (match.displayName) {
        return ensureDemExtension(match.displayName);
    }
    
    // Guard: Check if we have the necessary data
    if (!match.teams || match.teams.length < 2) {
        // Fallback to a descriptive name using match metadata
        const eventPart = match.event || 'Match';
        const stagePart = match.stage || 'Unknown';
        const idPart = match.id.substring(0, 8); // Use first 8 chars of ID
        return `${eventPart}_${stagePart}_${idPart}.dem`;
    }
    
    // Generate display name from match data
    const [teamA, teamB] = match.teams;
    const generatedName = `${teamA.name} - ${teamB.name} - ${match.map} - ${match.stage}`;
    return ensureDemExtension(generatedName);
};

